import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './Link.scss'

export const VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
}

const variantClassNameMapping = Object
  .values(VARIANTS)
  .reduce((acc, value) => ({ ...acc, [value]: `link--${value}` }), {})

const Link = ({
  children,
  href,
  rel,
  target,
  variant,
  className
}) => {
  const linkClassNames = classNames('link', variantClassNameMapping[variant], className)

  return (
    <a
      className={linkClassNames}
      href={href}
      rel={rel}
      target={target}
    >
      {children}
    </a>
  )
}

Link.defaultProps = {
  children: null,
  target: '_blank',
  rel: 'noopener noreferrer',
  variant: VARIANTS.PRIMARY,
  className: '',
  href: null
}

Link.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ]),
  rel: PropTypes.string,
  target: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string
}

export default Link
